import _ from "underscore";

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generateColumns(data) {
  let columnsArr = [];
  const keys = Object.keys(data[0]);
  _.each(keys, key => {
    const column = {
      Header: capitalizeFirstLetter(key),
      accessor: key,
      show:
        key === "remote_claimid" || key === "fileName" || key === "status"
          ? false
          : true
    };
    columnsArr.push(column);
  });
  return columnsArr;
}

export function mapDbClaimsToTableRow(dbClaim) {
  console.log("dbclaim",dbClaim)
  const tableClaim = {

    // diag_2: dbClaim.diag_2 ? dbClaim.diag_2 : null,
    // diag_3: dbClaim.diag_3 ? dbClaim.diag_3 : null,
    // diag_4: dbClaim.diag_4 ? dbClaim.diag_4 : null,
    // diag_5: dbClaim.diag_5 ? dbClaim.diag_5 : null,
    accept_assign: dbClaim.accept_assign,
    bill_addr_1: dbClaim.provider.bill_addr_1,
    bill_addr_2: dbClaim.provider.bill_addr_2,
    bill_city: dbClaim.provider.bill_city,
    bill_id: dbClaim.provider.bill_id,
    bill_name: dbClaim.provider.bill_name,
    bill_npi: dbClaim.provider.bill_npi,
    bill_phone: dbClaim.provider.bill_phone,
    bill_state: dbClaim.provider.bill_state,
    bill_taxid_type: dbClaim.provider.bill_taxid_type,
    bill_taxid: dbClaim.provider.bill_taxid,
    bill_zip: dbClaim.provider.bill_zip,
    charge_1: dbClaim.charge_1,
    charge_2: dbClaim.charge_2,
    charge_3: dbClaim.charge_3,
    charge_4: dbClaim.charge_4,
    charge_5: dbClaim.charge_5,
    claimLog: dbClaim.claimLog,
    claimmd_id: dbClaim.claimmd_id,
    diag_1: dbClaim.diag_1,
    diag_ref_1: dbClaim.diag_ref_1,
    diag_ref_2: dbClaim.diag_ref_2,
    diag_ref_3: dbClaim.diag_ref_3,
    diag_ref_4: dbClaim.diag_ref_4,
    diag_ref_5: dbClaim.diag_ref_5,
    error: dbClaim.error,
    file_name: dbClaim.batch.file_name,
    from_date_1: dbClaim.from_date_1,
    from_date_2: dbClaim.from_date_2,
    from_date_3: dbClaim.from_date_3,
    from_date_4: dbClaim.from_date_4,
    from_date_5: dbClaim.from_date_5,
    ins_number: dbClaim.patient.ins_number,
    line_items: dbClaim.line_items,
    mod1_1: dbClaim.mod1_1,
    mod1_2: dbClaim.mod1_2,
    mod1_3: dbClaim.mod1_3,
    mod1_4: dbClaim.mod1_4,
    mod1_5: dbClaim.mod1_5,
    pat_addr_1: dbClaim.patient.pat_addr_1,
    pat_addr_2: dbClaim.patient.pat_addr_2 ? dbClaim.patient.pat_addr_2 : null,
    pat_city: dbClaim.patient.pat_city,
    pat_dob: dbClaim.patient.pat_dob,
    pat_name_f: dbClaim.patient.pat_name_f,
    pat_name_l: dbClaim.patient.pat_name_l,
    pat_rel: dbClaim.patient.pat_rel,
    pat_sex: dbClaim.patient.pat_sex,
    pat_state: dbClaim.patient.pat_state,
    pat_zip: dbClaim.patient.pat_zip,
    payerid: dbClaim.payer.payerid,
    pcn: dbClaim.patient.pcn,
    place_of_service_1: dbClaim.place_of_service_1,
    place_of_service_2: dbClaim.place_of_service_2,
    place_of_service_3: dbClaim.place_of_service_3,
    place_of_service_4: dbClaim.place_of_service_4,
    place_of_service_5: dbClaim.place_of_service_5,
    prior_auth: dbClaim.prior_auth,
    proc_code_1: dbClaim.proc_code_1,
    proc_code_2: dbClaim.proc_code_2,
    proc_code_3: dbClaim.proc_code_3,
    proc_code_4: dbClaim.proc_code_4,
    proc_code_5: dbClaim.proc_code_5,
    orig_claim_ref: dbClaim.orig_claim_ref,
    remote_batchid: dbClaim.batch.remote_batchid,
    remote_claimid: dbClaim.remote_claimid,
    resubmission_code: dbClaim.resubmission_code,
    submission_count: dbClaim.submission_count,
    status: dbClaim.status,
    total_charge: dbClaim.total_charge,
    units_1: dbClaim.units_1,
    units_2: dbClaim.units_2,
    units_3: dbClaim.units_3,
    units_4: dbClaim.units_4,
    units_5: dbClaim.units_5,
     pickup_addr_1:dbClaim.pickup_addr_1,
      pickup_addr_2: dbClaim.pickup_addr_2 || null,
      pickup_city: dbClaim.pickup_city,
      pickup_state:dbClaim.pickup_state,
      pickup_zip: dbClaim.pickup_zip,
     dropoff_addr_1: dbClaim.dropoff_addr_1,
      dropoff_addr_2: dbClaim.dropoff_addr_2 || null,
      dropoff_city: dbClaim.dropoff_city,
      dropoff_state: dbClaim.dropoff_state,
      dropoff_zip:dbClaim.dropoff_zip,

  };
  return tableClaim;
}

export const mapCSVtoTable = uploadedClaims => {
  const displayedClaims = [];
  _.map(uploadedClaims, claim => {
    const newClaim = {
      "Date of Service": claim.from_date_1,
      "Patient ID": claim.pcn,
      "First Name": claim.pat_name_f,
      "Last Name": claim.pat_name_l,
      "Insurance Number": claim.ins_number,
      Payer: claim.payerid,
      "Total Charge": claim.total_charge,
      remote_claimid: claim.remote_claimid,
      status: claim.status,
      fileName: claim.file_name
    };
    displayedClaims.push(newClaim);
  });
  return displayedClaims;
};

export function toggleStyle(index) {
  if (index % 2 !== 0) {
    return "recent-batch-grey";
  }
}

export const boolToggle = val => {
  return !val;
};

export const convertFieldName = (field) => {
  switch (field) {
    case 'from_date_1':
      return "Date of Service"
    case 'pat_name_f':
      return "First Name"
    case 'pat_name_l':
      return "Last Name"
    case 'pat_dob':
      return "Date of Birth"
    case 'pat_sex':
      return "Sex"
    case 'ins_number':
      return "Insured ID Number"
    case 'prior_auth':
      return "Prior Authorization #"
    case 'pat_addr_1':
      return "Address Line 1"
    case 'pat_addr_2':
      return "Address Line 2"
    case 'pat_state':
      return "State"
    case 'pat_city':
      return "City"
    case 'pat_zip':
      return "Zip"
    case 'diag_1' || 'diag_2' || 'diag_3' || 'diag_4' || 'diag_5':
      return "Diagnosis Code"
    case 'proc_code_1' || 'proc_code_2' || 'proc_code_3' || 'proc_code_4' || 'proc_code_5':
      return "Procedure Code"
    case 'mod1_1' || 'mod1_2' || 'mod1_3' || 'mod1_5' || 'mod1_5' :
      return "Modifier"
    case 'units_1' || 'units_2' || 'units_3' || 'units_4' || 'units_5':
      return "Units"
    case 'charge_1' || 'charge_2' || 'charge_3' || 'charge_4' || 'charge_5':
      return "Charge"
    default:
       return "Error"
  }
}
//  export const nameToPayerid=(name)=>{
//   switch (name) {
//       case "Aetna":
//       return "60054"
//       case "Fidelis Care New York":
//       return "11315"
//       case "Metro Plus Health Plan":
//       return "13265"
//     default:
//     return "No match"
//   }
// }


export const wrapObject = data => {
  if (_.isArray(data)) {
    return data; // return array
  } else {
    return [data]; // return object wrapped in array
  }
};


export const b64toBlob = (b64Data, contentType) => {
  contentType = contentType || '';
  var sliceSize = 512;
  b64Data = b64Data.replace(/^[^,]+,/, '');
  b64Data = b64Data.replace(/\s/g, '');
  var byteCharacters = window.atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: "application/pdf" });
  return blob;

}






// WEBPACK FOOTER //
// ./src/app/utilities/common_functions.js